export const getPortalNamespace = (pathname) => {
  const path = pathname || window.location.pathname;
  if (path.startsWith("/superadmin")) return "superadmin";
  if (path.startsWith("/exhibitor")) return "exhibitor";
  if (path.startsWith("/agent")) return "agent";
  if (path.startsWith("/sponser")) return "sponser";
  if (path.startsWith("/associate")) return "associate";
  if (path.startsWith("/adminvip")) return "adminvip";
  if (path.startsWith("/hospitality")) return "hospitality";
  if (path.startsWith("/cab-service")) return "cabservice";
  if (path.startsWith("/flight-service")) return "flightservice";
  if (path.startsWith("/buyer-admin")) return "buyeradmin";
  if (path.startsWith("/visitor-admin")) return "visitoradmin";
  if (path.startsWith("/subadmin")) return "subadmin";
  if (path.startsWith("/hotelmanagement")) return "hotelmanagement";
  if (path.startsWith("/cabmanagement")) return "cabmanagement";
  return null;
};

export const getLoginPath = (namespace) => {
  const ns = namespace || getPortalNamespace();
  if (!ns) return "/";
  if (ns === "cabservice") return "/cab-service/login";
  if (ns === "flightservice") return "/flight-service/login";
  if (ns === "buyeradmin") return "/buyer-admin/login";
  if (ns === "visitoradmin") return "/visitor-admin/login";
  return `/${ns}/login`;
};

export const getBasePath = (namespace) => {
  const ns = namespace || getPortalNamespace();
  if (!ns) return "";
  if (ns === "cabservice") return "/cab-service";
  if (ns === "flightservice") return "/flight-service";
  if (ns === "hotelmanagement") return "/hotelmanagement";
  if (ns === "cabmanagement") return "/cabmanagement";
  if (ns === "buyeradmin") return "/buyer-admin";
  if (ns === "visitoradmin") return "/visitor-admin";
  return `/${ns}`;
};

export const getAuthKey = (key, namespace) => {
  const ns = namespace || getPortalNamespace();
  return ns ? `${ns}_${key}` : key;
};

export const storage = {
  get: (key, namespace) => {
    return localStorage.getItem(getAuthKey(key, namespace));
  },
  set: (key, value, namespace) => {
    localStorage.setItem(getAuthKey(key, namespace), value);
  },
  remove: (key, namespace) => {
    localStorage.removeItem(getAuthKey(key, namespace));
  },
  clearNamespace: (namespace) => {
    const ns = namespace || getPortalNamespace();
    if (!ns) return;
    const keysToRemove = ["token", "permission", "user_id", "category", "type_of_user"];
    keysToRemove.forEach((k) => localStorage.removeItem(`${ns}_${k}`));
  },
};
